export default __webpack_public_path__ + "static/media/dashboard_banner_clinic.73d3765f.png";